import React, { useRef } from 'react';
import { useWatch } from 'react-hook-form-v7';
import CollapsibleFilterWrapper from '../CollapsibleFilterWrapper';
import ConnectedDateRangePicker, { getDateRangePickerInputNames } from './ConnectedDateRangePicker';

const CollapsibleDateRange = ({ control, name, label }) => {
    const dateRangePickerRef = useRef(null);
    const { inputNameFrom, inputNameTo } = getDateRangePickerInputNames(name);

    const [dateFrom, dateTo] = useWatch({ control, name: [inputNameFrom, inputNameTo] });

    const handleReset = () => dateRangePickerRef.current.clear(); // TODO: Add reset to default values logic

    return (
        <CollapsibleFilterWrapper
            label={`${label} (${dateFrom || dateTo ? 1 : 0})`}
            onReset={handleReset}
        >
            <ConnectedDateRangePicker ref={dateRangePickerRef} control={control} name={name} />
        </CollapsibleFilterWrapper>
    );
};

export default CollapsibleDateRange;
